import { useResourceQuery } from "~graphql/generated/graphql"

export default function useResource({
    resourceId,
}: {
    resourceId?: string | null
}) {
    const { data, loading, refetch, error } = useResourceQuery({
        variables: { id: resourceId ?? "" },
        skip: !resourceId,
        fetchPolicy: "no-cache",
    })

    const resource = data?.resource

    return { resource, isLoading: loading, refetch, error }
}
